module.exports = __webpack_public_path__ + "images/application/credit-a1116f6c.svg";